import { scrollTileHorizontallyIntoView } from './scroll-tile-horizontally-into-view';

export const scrollSelectedTileIntoView = (container: HTMLElement) => {
    const tiles = container.querySelectorAll<HTMLElement>('.js_pdp_dimension-selection__scrollable-tile');
    tiles.forEach(tile => {
        if (tile.dataset.qaDimensionItem !== 'selected') return;
        scrollTileHorizontallyIntoView(container, tile);
    });
};
